<h2 mat-dialog-title>
    Abrir caixa
</h2>
<div mat-dialog-content>
    <mat-form-field class="full-width">
        <mat-label>Valor inicial</mat-label>
        <input matInput type="number" [(ngModel)]="value"/>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button *ngIf="!isRequired" mat-button (click)="onCancel()">{{ 'cancel' | transloco }}</button>
    <button
        mat-raised-button
        color="primary"
        [disabled]="value === null || value === undefined || loading"
        (click)="onSave()">
        Abrir
    </button>
</div>
